var { accent } = require('../common.js')

var shell = require('shelljs')

function commit(yargs) {

	const message = yargs.argv._.slice(1, yargs.argv._.length).join(' ')
		|| "stash"

	const { stdout, stderr } = shell.exec(
		`git add -A && git commit -m "${message}"`,
		{ silent: true }
	)

	console.log(accent('ops commit --'), `"${message}"`)

}

module.exports = commit



// WEBPACK FOOTER //
// ./src/commands/commit.js